import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { FeedService } from '../../services/feed.service';
import { ToastService } from 'src/app/core/toast.service';
import { DeletePopupComponent } from 'src/app/modules/dashboard/delete-popup/delete-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { Tables } from 'src/app/shared/enum/tables.enum';
import { CommonServicesForAllModules } from 'src/app/shared/common/service';
import { Overlay } from '@angular/cdk/overlay';
import { LoginService } from 'src/app/core/services/login.service';

@Component({
  selector: 'app-list-newsfeed-category',
  templateUrl: './list-newsfeed-category.component.html',
  styleUrls: ['./list-newsfeed-category.component.scss']
})
export class ListNewsfeedCategoryComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['sNo', 'category_name', 'created_at', 'updated_at', 'action'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  selection = new SelectionModel<any>(true, []);
  totalElements = 0;
  offset = { value: 0 };
  limit = { value: 10 };
  category: any[] = [];
  communityId: string | null = null; // New: holds community ID if any
  loginDetails:any;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public feedService: FeedService,
    private toast: ToastService,
    private dialog: MatDialog,
    private CommonServices: CommonServicesForAllModules,
    private overlay: Overlay,
    private loginService: LoginService,

  ) {}

  ngOnInit(): void {

    this.loginDetails = this.loginService.getLoginData();
    // Check if this route has a community ID
    this.route.params.subscribe(params => {
      this.communityId = params['communityId'] || null;
      this.getCategories();
    });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getCategories() {
    if (this.communityId) {
      // Community user: fetch categories for this community
      this.feedService.getNewsFeedsCategoriesByCommunity(this.communityId).subscribe({
        next: (data) => this.setCategories(data),
        error: (err) => this.handleError(err)
      });
    } else {
      // Normal user: fetch all categories (existing functionality)
      this.feedService.getNewsFeedsCategories().subscribe({
        next: (data) => this.setCategories(data),
        error: (err) => this.handleError(err)
      });
    }
  }


  private setCategories(data: any[]) {
    if (Array.isArray(data)) {
      // Keep static Catalog category
      this.category = [
        { category_name: 'Catalog', created_at: new Date(), updated_at: new Date() },
        ...data
      ];
      this.dataSource.data = this.category;
    } else {
      console.error("Expected an array but received:", data);
      this.dataSource.data = [
        { category_name: 'Catalog', created_at: new Date(), updated_at: new Date() }
      ];
    }
  }

  private handleError(err: any) {
    console.error("Error fetching categories:", err);
    this.dataSource.data = [
      { category_name: 'Catalog', created_at: new Date(), updated_at: new Date() }
    ];
  }

  editCategories(category: any) {
  if (category.id) {
    // Navigate to Edit page using route param (category id)
    this.router.navigate(['/profile/list-newsfeed-category/edit', category.id]);
  }
}

  deleteCategories(category: any) {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '600px',
      data: { item: category, name: 'Category' },
      scrollStrategy: this.overlay.scrollStrategies.noop(),
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response === 'yes' && category.id) {
        this.CommonServices.DeleteById(Tables.NewsfeedCategories, category.id).then(() => {
          this.getCategories();
          this.toast.openSnackBar('Category Deleted successfully');
        });
      }
    });
  }

  addNewsfeedCategory(): void {
  if (this.communityId) {
    this.router.navigate(['/profile/add-newsfeeds', this.communityId]);
  } else {
    this.router.navigate(['../add-newsfeeds'], { relativeTo: this.route });
  }
}
}